// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Preloader_wrapper__rggcO","appear":"Preloader_appear__-DSBY","pulse":"Preloader_pulse__5VJpx","logo":"Preloader_logo__zEmgG"};